module.exports = __webpack_public_path__ + "img/icon_pedometer.0663bfa2.png";